import styled from 'styled-components';
import { H3 } from 'components/Heading';

export const Heading = styled(H3)`
  margin-bottom: 10px;
  white-space: nowrap;
`;

export const Name = styled(H3)`
  display: inline;
  text-transform: uppercase;
  text-decoration: none;
`;
